
import Vue from 'vue';

import { CvToastNotification } from '@carbon/vue';

type ColorStatusType = 'success' | 'warning' | 'error';

export default Vue.extend({
  name: 'SmallDetailsNotification',
  components: {
    CvToastNotification,
  },

  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      isVisible: this.data && this.data.validatorColor !== 'Green',
    };
  },

  computed: {
    kind(): ColorStatusType {
      return {
        Green: 'success',
        Orange: 'warning',
        Red: 'error',
      }[
        this.data.validatorColor as 'Green' | 'Orange' | 'Red'
      ] as ColorStatusType;
    },
  },

  watch: {
    data() {
      this.isVisible = this.data && this.data.validatorColor !== 'Green';
    },
  },

  methods: {
    validatorColorTranslation() {
      if (this.data.validatorColor === 'Orange') {
        return this.$t('small-details.status.orange');
      } else if (this.data.validatorColor === 'Red') {
        return this.$t('small-details.status.red');
      } else {
        return this.$t('small-details.status.green');
      }
    },
  },
});
